import { NavigateFunction } from 'react-router-dom';

/**
 * Navigate to a route and scroll to the top of the page
 * This ensures that when users click footer links, they see the top of the new page
 */
export const navigateWithScrollToTop = (navigate: NavigateFunction, route: string): void => {
    // Navigate to the route
    navigate(route);

    // Scroll to top after navigation
    // Use setTimeout to ensure the navigation completes first
    setTimeout(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
    }, 100);
};

/**
 * Navigate to a route with anchor and scroll to the top first, then to the anchor
 * This handles cases where we want to go to a specific section on a page
 */
export const navigateWithAnchor = (
    navigate: NavigateFunction,
    route: string,
    anchor: string
): void => {
    // Navigate to the route
    navigate(route);

    // First scroll to top, then to the anchor
    setTimeout(() => {
        // Scroll to top first
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });

        // Then scroll to the anchor after a short delay
        setTimeout(() => {
            const element = document.getElementById(anchor);
            if (element) {
                element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                });
            }
        }, 300);
    }, 100);
};
